import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { GeneralSettingsKeys, NavgationPageLocationKey } from '../../../utils/constants';
import { Button, Card, CardBody, CardHeader, Col, Container, Row } from 'shards-react';
import { formatNumberAmount } from '../../../utils/general';
import { setDateForTable } from '../../../utils/date';
import ReactTable from 'react-table';
import { download_client_invoice, get_client_invoice_by_refnum, reset_client_invoice_details } from '../../../redux/actions/client/clientInvoice';

const NewClientInvoice = ({ get_client_invoice_by_refnum, invoiceObject
    , download_client_invoice, reset_client_invoice_details
}) => {
    const location = useLocation();
    const [refNum, setrefNum] = useState(0);

    const history = useHistory();
    const [initialState, setInitialState] = useState({
        refNum: refNum,
        clientName: "",
        currency: '',
        invoiceDate: '',
        dueDate: '',
        invoiceStatus: '',
        receivedAmount: 0,
        balanceDue: 0,
        totalGross: 0,
        totalTax: 0,
        totalAmount: 0,

        invoiceItems: [],
        clientInvoicePayment: [],
    })

    const [formData, setFormData] = useState(initialState)
    const [historyTableData, setHistoryTableData] = useState([])
    const [invoiceDetailData, setInvoiceDetailData] = useState([])

    useEffect(() => {
        if (refNum === 0) {
            if (location.state !== undefined) {
                //Take from state --> Also Add screnario will fall here
                let itemId = location.state?.refNum !== undefined ? location.state?.refNum : 0;
                setrefNum(itemId);
                if (Number(itemId) !== 0) {
                    get_client_invoice_by_refnum(itemId);
                }

                setFormData({
                    ...formData
                    , refNum: itemId
                })
            }
            else if (localStorage.getItem(NavgationPageLocationKey.ClientInvoiceAddEdit) !== null) {
                //Take from local storage 
                let storageRefNum = localStorage.getItem(NavgationPageLocationKey.ClientInvoiceAddEdit);
                setrefNum(storageRefNum);
                get_client_invoice_by_refnum(storageRefNum)
                //Set state for same page
                const newState = { refNum: storageRefNum }
                history.push(location.pathname, newState);
                localStorage.removeItem(NavgationPageLocationKey.ClientInvoiceAddEdit);
            }
        }
        return () => {
            reset_client_invoice_details()
        }
    }, [])

    const onEditInvoicePaymentItem = (e, refNum) => {
        e.preventDefault();
        let passingObj = { 
            refNum: refNum
            , invoiceRefNum: formData.refNum
            , currency: formData.currency
            , dueDate: formData.dueDate
            , balanceDue: formData.balanceDue
            , invoiceAmount: formData.totalAmount
            , clientName: formData.clientName
         }
        history.push({
            pathname: `/client-invoices-payment`,
            state: { paymentInfo: passingObj }
        });
        return false;
    }

    const historyTableColumns = [
        {
            Header: "Date",
            accessor: "paymentDate",
            minWidth: 120,
            Cell: row => setDateForTable(row.original.paymentDate)
        },
        {
            Header: "Payment Currency",
            accessor: "paymentCurrency",
            minWidth: 100,
            Cell: row => <span className="w-100">{row.original.paymentCurrency}</span>
        },
        {
            Header: "Payment Amount",
            accessor: "paymentAmount",
            minWidth: 140,
            Cell: row => <span className="w-100 text-right">{formatNumberAmount(row.original.paymentAmount, 'en-US', 2, 2)}</span>
        },
        {
            Header: "FX Rate",
            accessor: "fxRate",
            minWidth: 100,
            Cell: row => <span className="w-100">{formatNumberAmount(row.original.fxRate, 'en-US', 5, 5)}</span>
        },
        {
            Header: "Amount " + formData.currency,
            accessor: "amount",
            minWidth: 150,
            Cell: row => <span className="w-100 text-right">{formatNumberAmount(row.original.amount, 'en-US', 2, 2)}</span>
        },
        {
            Header: " ",
            accessor: "",
            minWidth: 50,
            Cell: row => <span><img src="./icons/edit-square.svg" role="button" height="17.5" width="17.5" className="mr-2"
                onClick={(e) => { onEditInvoicePaymentItem(e, row.original.refNum); }}></img>
            </span>
        }
    ]

    const invoiceDetailsColumns = [
        {
            Header: "Description",
            accessor: "description",
            minWidth: 350,
        },
        {
            Header: "Week Ending",
            accessor: "weekendingDate",
            minWidth: 95,
            Cell: row => setDateForTable(row.original.weekendingDate)
        },
        {
            Header: "Hrs/Qty",
            accessor: "hrsQty",
            minWidth: 70,
            Cell: row => <span className="w-100 text-right">{formatNumberAmount(row.original.hrsQty, 'en-US', 2, 2)}</span>
        },
        {
            Header: "Rate",
            accessor: "invoiceItemRate",
            minWidth: 90,
            classNames: 'text-right',
            Cell: row => <span className="w-100 text-right">{formatNumberAmount(row.original.invoiceItemRate, 'en-US', 4, 4)}</span>
        },
        {
            Header: "Gross",
            accessor: "gross",
            minWidth: 90,
            classNames: 'text-right',
            Cell: row => <span className="w-100 text-right">{formatNumberAmount(row.original.gross, 'en-US', 2, 2)}</span>,
            Footer: <div className="d-flex w-100 justify-content-end text-nowrap">
                <span>{formatNumberAmount(invoiceDetailData.totalGross, 'en-US', 2, 2)}</span>
            </div>
        },
        {
            Header: "Tax",
            accessor: "tax",
            minWidth: 70,
            classNames: 'text-right',
            Cell: row => <span className="w-100 text-right">{formatNumberAmount(row.original.tax, 'en-US', 2, 2)}</span>,
            Footer: <div className="d-flex w-100 justify-content-end text-nowrap">
                <span>{formatNumberAmount(invoiceDetailData.totalTax, 'en-US', 2, 2)}</span>
            </div>
        },
        {
            Header: "Total",
            accessor: "total",
            minWidth: 105,
            Cell: row => <span className="w-100 text-right">{formatNumberAmount(row.original.total, 'en-US', 2, 2)}</span>,
            Footer: <div className="d-flex w-100 justify-content-end text-nowrap">
                <span>{formatNumberAmount(invoiceDetailData.grandTotal, 'en-US', 2, 2)}</span>
            </div>
        }
    ]

    const calculateAndFixTableData = (invoicedData) => {
        if(invoicedData === undefined)
            return false;

        var revisedList = invoicedData;
        var totalGross = revisedList.reduce((x, i) => Number(x) + Number(i.gross), 0);
        var totalTax = revisedList.reduce((x, i) => Number(x) + Number(i.tax), 0);
        var grandTotal = revisedList.reduce((x, i) => Number(x) + Number(i.total), 0);
        var revisedObject = {
            data: revisedList,
            totalGross: totalGross,
            totalTax: totalTax,
            grandTotal: grandTotal
        } 
        setInvoiceDetailData({...revisedObject});
    }

    useEffect(() => {
        if(invoiceObject !== null && invoiceObject !== undefined) {
            let rawData = { ...formData}
            rawData.refNum = invoiceObject?.refNum
            rawData.clientName = invoiceObject?.clientName
            rawData.currency = invoiceObject?.currency
            rawData.invoiceDate = invoiceObject?.invoiceDate
            rawData.dueDate = invoiceObject?.dueDate
            rawData.invoiceStatus = invoiceObject?.invoiceStatus
            rawData.receivedAmount = invoiceObject?.receivedAmount
            rawData.balanceDue = invoiceObject?.balanceDue
            rawData.totalGross = invoiceObject?.totalGross
            rawData.totalTax = invoiceObject?.totalTax
            rawData.totalAmount = invoiceObject?.totalAmount

            if(invoiceObject?.invoiceItems !== undefined && invoiceObject?.invoiceItems.length > 0){
                rawData.invoiceItems = invoiceObject.invoiceItems
                calculateAndFixTableData(invoiceObject.invoiceItems);
            }

            if(invoiceObject?.clientInvoicePayment !== undefined && invoiceObject?.clientInvoicePayment.length > 0){
                rawData.clientInvoicePayment = invoiceObject.clientInvoicePayment
                setHistoryTableData(invoiceObject.clientInvoicePayment);
            }
            setFormData({ ...formData, ...rawData });
        }
    }, [invoiceObject])

    const downloadInvoice = (e) => {
        e.preventDefault();
        let apiJson = { refNumList: [formData.refNum] }
        download_client_invoice(apiJson);
    }

    const prepareInvoiceForPayment = (e) => {
        e.preventDefault()
        let passingObj = { 
            refNum: 0
            , invoiceRefNum: formData.refNum
            , currency: formData.currency
            , dueDate: formData.dueDate
            , balanceDue: formData.balanceDue
            , invoiceAmount: formData.totalAmount
            , clientName: formData.clientName
         }
        history.push({
            pathname: `/client-invoices-payment`,
            state: { paymentInfo: passingObj }
        });
        return false;
    }

    return (
        <Container fluid className="main-content-container px-4 pb-4 bg-white mt-2">
            <Card>
                <CardHeader>
                    <div className="page-header tableSearch client_invoice flex-column flex-md-row py-2 d-flex btn-accent mt-4 ">

                        <div className="d-flex align-items-center ml-3 mt-1 mb-1 p-1 bg-white">
                        </div>

                        <div className="form-group p-2 mb-0 ml-1 col-lg-2">
                            <div>
                                <label>Bill To </label>
                            </div>
                            <div className=''>
                                <span>{formData.clientName}</span>
                            </div>
                        </div>

                        <div className="form-group p-2 mb-0 ml-1 col-lg-2">
                            <div>
                                <label><i>Invoice Amount</i> </label>
                            </div>
                            <div className=''>
                                <span>{formatNumberAmount(formData.totalAmount, 'en-US', 2, 2)} {formData.currency}</span>
                            </div>
                        </div>

                        <div className="form-group p-2 mb-0 ml-1 col-lg-2">
                            <div>
                                <label>Invoice Date</label>
                            </div>
                            <div className=''>
                                <span>{setDateForTable(formData.invoiceDate)}</span>
                            </div>
                        </div>

                        <div className="d-flex align-items-center p-2 col-lg-1 invRefBoxMargin">
                            <div className="d-flex align-items-center p-2 invRefBox" style={{marginTop: "23px"}}>
                                {'INV-' + formData.refNum}
                            </div>
                        </div>

                        <div className="form-group p-2 mb-0 ml-1 col-lg-2 float_right">
                            <div>
                                <label><i>Balance Due</i> </label>
                            </div>
                            <div className=''>
                                <span>{formatNumberAmount(formData.balanceDue, 'en-US', 2, 2)} {formData.currency}</span>
                            </div>
                        </div>

                        <div className="form-group p-2 mb-0 ml-1 col-lg-2">
                            <div>
                                <label>Due Date </label>
                            </div>
                            <div className=''>
                                <span>{setDateForTable(formData.dueDate)}</span>
                            </div>
                        </div>
                    </div>
                </CardHeader>
                <CardBody className="paddingtopzero w-100">

                    <Row>
                        <Col lg="5">
                            <div className="d-flex align-items-center  p-2">
                                <Button className="mx-2 py-2 my-2" size='sm' theme="accent"
                                    onClick={prepareInvoiceForPayment}>
                                    Make a Payment
                                </Button>
                                <Button className="mx-2 py-2 my-2" size='sm' theme="accent"
                                    onClick={downloadInvoice}>
                                    <i className="fa fa-download"></i> Download
                                </Button>
                            </div>
                        </Col>
                        <Col lg="7" className=''>
                            <div className='d-flex align-items-center justify-content-center pb-2'>
                                <span>Invoice Payment History</span>
                            </div>
                            <div className='custom-header justify-content-center border'>
                                <ReactTable
                                    columns={historyTableColumns}
                                    data={historyTableData}
                                    pageSize={Number(historyTableData.length === 0 ? 0 : historyTableData.length)}
                                    showPageSizeOptions={false}
                                    resizable={false}
                                    pagination={false}
                                    showPaginationBottom={false}
                                    className="w-100 h-90 overflowAuto"
                                    noDataText=" "
                                />
                            </div>
                        </Col>
                    </Row>
                    <div className='mt-3 pb-2'>
                        <span>Invoice Details</span>
                    </div>
                    <div className='d-flex align-items-center justify-content-center w-100 h-100 border'>
                        <ReactTable
                            columns={invoiceDetailsColumns}
                            data={invoiceDetailData.data}
                            pageSize={Number(invoiceDetailData.data?.length)}
                            showPageSizeOptions={false}
                            resizable={false}
                            pagination={false}
                            showPaginationBottom={false}
                            className="w-100 "
                            noDataText=" "
                        />
                    </div>
                </CardBody>
            </Card>
        </Container>
    )
}

const mapStateToProps = (state) => ({
    invoiceObject: state.clientInvoice.invoiceObject
})
export default connect(mapStateToProps, {
    get_client_invoice_by_refnum,
    download_client_invoice,
    reset_client_invoice_details,
})(NewClientInvoice)